export const CATEGORY_TYPES = {
  TECHNOLOGY: 'technology',
  THEME: 'theme',
  SEGMENT: 'segment',
  CONTENT: 'content'
} as const;

export interface Author {
  name: string;
}

export interface FeaturedImage {
  url: string;
}

export interface ContentHeaderBlock {
  id: string;
  title: string;
  subTitle: string;
  summary: string;
  authors: Author[];
  customerSegment: string[];
  technologyVertical: string;
  themes: string[];
  featuredImage: FeaturedImage;
  categoryTags: CategoryTag[];
}

export interface Image {
  url: string;
  caption: string;
  fileName: string;
  sourceUrl: string;
}

export interface HygraphTable {
  html: string;
}

export interface HygraphText {
  html: string;
}

export interface SectionContentImage {
  id: string;
  image?: Image[];
}

export interface SectionContentTable {
  id: string;
  caption: string;
  table?: HygraphTable[];
}

export interface SectionContentText {
  id: string;
  body?: HygraphText[];
}

export type SectionContent = SectionContentImage | SectionContentTable | SectionContentText;

export interface Section {
  title: string;
  subTitle: string;
  complimentaryContent: boolean;
  sectionContent: SectionContent[];
}

export interface ContentBodyBlock {
  id: string;
  section: Section[];
}

export interface Analysis {
  analysisCode: string;
}

export interface RelatedContent {
  id: string;
  reportTitle?: string;
  blogTitle?: string;
  blogId?: string;
  contentType: string;
  publishDate: string;
  blogPublishDate?: string;
  analysisCode?: string;
}

export interface Report {
  id: string;
  title: string;
  templateType: string;
  includeRelatedContent: boolean;
  includeTableOfContent: boolean;
  updatedAt: string;
  analyses: Analysis[];
  contentBodyBlock: ContentBodyBlock;
  relatedContent: RelatedContent[];
  publishDate: string;
  contentHeaderBlock?: ContentHeaderBlock;
  subTitle: string;
  summary: string;
  authors: Author[];
  customerSegment: string[];
  technologyVertical: string;
  themes: string[];
  featuredImage: FeaturedImage;
  categoryTags: CategoryTag[];
  categoryTagDefaults: CategoryTag[];
  ignoreDefaultTags: boolean;
}

export interface CategoryTag {
  categoryType: string;
  key: string;
  displayName: string;
}

export interface ReportResponse {
  assetId: string;
  content: Report;
  name: string;
  asset_classification: string;
  creation_date: string;
  size: number;
  type: string;
}

export interface HTMLReport {
  header: ContentHeaderBlock;
  sections: Section[];
  publishDate: Date;
  name: string;
  relatedContent: RelatedContent[];
  includeTableOfContent: boolean;
  includeRelatedContent: boolean;
}

export const HYGRAPH_REPORT_QUERY = `
      query getReportData($id: ID!) {
        report(where: {id: $id}, stage: PUBLISHED) {
          relatedContent {
            ... on Analysis {
              id
              analysisCode
              contentType
              publishDate
              reportTitle: title
            }
            ... on Post {
              id
              blogId
              contentType
              blogPublishDate:publishDate
              blogTitle:title
            }
          }
          id
          title
          templateType
          includeRelatedContent
          includeTableOfContents
          publishedAt
          updatedAt
          analyses(first: 500) {
            analysisCode
          }
          contentHeaderBlock {
            id
            title
            subTitle
            summary
            authors {
              name
            }
            customerSegment
            technologyVertical
            theme
            featuredImage {
              url
            }
          }
          contentBodyBlock {
            id
            section {
              title
              subTitle
              complimentaryContent
              sectionContent {
                ... on SectionContentImage {
                  id
                  image {
                    url
                    altText
                    fileName
                    sourceUrl
                  }
                }
                ... on SectionContentTable {
                  id
                  table {
                    html
                  }
                }
                ... on SectionContentText {
                  id
                  body {
                    html
                  }
                }
              }
            }
          }
        }
      }
    `;
